export interface AvatarCustomization {
  skinTone: string;
  hairColor: string;
  topColor: string;
  bottomColor: string;
  accentColor: string;
}

export const DEFAULT_AVATAR_CUSTOMIZATION: AvatarCustomization = {
  skinTone: "#f5d0b5",
  hairColor: "#3d2314",
  topColor: "#8b5cf6",
  bottomColor: "#312e81",
  accentColor: "#f472b6",
};

export const MALE_AVATAR_CUSTOMIZATION: AvatarCustomization = {
  skinTone: "#ddb896",
  hairColor: "#14100c",
  topColor: "#334155",
  bottomColor: "#1e293b",
  accentColor: "#38bdf8",
};

export const INSTRUCTOR_AVATAR_CUSTOMIZATION: AvatarCustomization = {
  skinTone: "#c9a27a",
  hairColor: "#0c0c0c",
  topColor: "#18181b",
  bottomColor: "#27272a",
  accentColor: "#d946ef",
};

export type DefaultAvatarGender = "female" | "male";

export interface ClassroomPosition {
  x: number;
  y: number;
  z: number;
}

export interface ClassroomParticipant {
  userId: string;
  displayName: string;
  role: "instructor" | "student";
  position: ClassroomPosition;
  rotation: number;
  modelUrl?: string;
  customization: AvatarCustomization;
  updatedAt: number;
}

export interface WhiteboardStroke {
  id: string;
  points: Array<{ x: number; y: number }>;
  color: string;
  width: number;
}

export type ClassroomMessage =
  | {
      type: "presence";
      participant: ClassroomParticipant;
    }
  | {
      type: "whiteboard";
      strokes: WhiteboardStroke[];
      fromUserId: string;
    }
  | {
      type: "whiteboard-panel";
      open: boolean;
      fromUserId: string;
    }
  | {
      type: "summon";
      targetUserId: string;
      position: ClassroomPosition;
      fromUserId: string;
    }
  | {
      type: "leave";
      userId: string;
    }
  | {
      type: "audio-state";
      fromUserId: string;
      audioUrl: string | null;
      audioFileName?: string | null;
      playing: boolean;
      currentTime: number;
      duration: number;
      revision: number;
      sentAt: number;
    }
  | {
      type: "audio-state-request";
      fromUserId: string;
    }
  | {
      type: "chat";
      id: string;
      senderUid: string;
      senderRole: "instructor" | "student";
      content: string;
      sentAt: number;
    };

export const CLASSROOM_DATA_TOPIC = "classroom";
